import React from 'react';
import { Container, Image, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { HiQuestionMarkCircle } from 'react-icons/hi';
import { BiLogOut } from 'react-icons/bi';
import './Topbar.css';
import { GroupedRoutes } from '../routes/routes';
import IRouter, { IGroupedRouter } from '../Interface/IRouter';
import { useAllowedPages } from '../../context/AllowedPagesContext';
import Auth from '../Auth/auth';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher';
import { useTheme } from '../../theme/useTheme';
import MhcetLogo from "../../assests/Mhcet_Logo.png"

export default function TopBar() {
  let navigate = useNavigate();
  const location = useLocation();
  const { isPageAllowed, clearAllowedPages } = useAllowedPages();
  const { colors } = useTheme();


  const handleLogout = () => {
    Auth.signout();
    clearAllowedPages();
    navigate('/login');
  };

  return (
    <>
      <Navbar
        className="modern-navbar"
        expand="lg"
        sticky="top"
        style={{
          background: '#ffffff !important',
          borderBottom: `1px solid ${colors.border.secondary}`,
        }}
      >
        <Container fluid className="px-4">
          <Navbar.Brand
            onClick={() => navigate('/dashboard')}
            className="navbar-brand-modern fw-bold"
            style={{
              cursor: 'pointer',
              color: colors.primary.main,
            }}
          >
            <div className="brand-wrapper">
              <span className="brand-icon" style={{ color: colors.primary.main }}>
                {/* ✦ */}
                <Image src={MhcetLogo} alt="MHCET Logo" className="brand-logo" style = {{width: 40, height: 40}} />
                </span> 
            </div>
            {/* <span className="brand-version-badge">v3.1</span> */}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-toggle-modern" />
          <Navbar.Collapse id="basic-navbar-nav">

            {
              isPageAllowed('dashboard') &&
              <Nav className="nav-links">
                <Nav.Link
                  onClick={() => navigate('/dashboard')}
                  className={`nav-link-modern ${location.pathname === '/dashboard' ? 'active-modern' : ''}`}
                >
                  Dashboard
                </Nav.Link>
              </Nav>
            }

            {GroupedRoutes.map((data: IGroupedRouter, index: number) => {
              if (!data.navbarShow) return null;

              const allowedChildren = data.children.filter((child: IRouter) =>
                child.navbarShow && isPageAllowed(child.path)
              );

              if (allowedChildren.length === 0) return null;

              if (allowedChildren.length === 1) {
                const singleChild = allowedChildren[0];
                return (
                  <Nav key={index}>
                    <Nav.Link
                      onClick={() => navigate(singleChild.path)}
                      className={`nav-link-modern ${location.pathname.includes(singleChild.path) ? 'active-modern' : ''}`}
                    >
                      {singleChild.name}
                    </Nav.Link>
                  </Nav>
                );
              }

              const isGroupActive = allowedChildren.some((child: IRouter) =>
                location.pathname.includes(child.path)
              );

              return (
                <Nav key={index}>
                  <NavDropdown
                    title={data.name}
                    id={`nav-dropdown-${index}`}
                    className={`nav-dropdown-modern ${isGroupActive ? 'active-modern' : ''}`}
                    menuVariant="dark"
                  >
                    {allowedChildren.map((child: IRouter, idx: number) => (
                      <NavDropdown.Item
                        key={idx}
                        onClick={() => navigate(child.path)}
                        className={`dropdown-item-modern ${location.pathname.includes(child.path) ? 'active-modern' : ''}`}
                      >
                        {child.name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                </Nav>
              );
            })}
          </Navbar.Collapse>

          <Nav className="profile-nav-modern">
            <div className="profile-actions-group">
              <ThemeSwitcher />
              <button
                className="help-icon-btn"
                onClick={() => window.open('https://help.example.com', '_blank')}
                title="Help"
                style={{
                  borderColor: colors.border.secondary,
                  color: colors.text.secondary,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = colors.primary.main;
                  e.currentTarget.style.color = colors.primary.main;
                  e.currentTarget.style.backgroundColor = colors.background.secondary;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = colors.border.secondary;
                  e.currentTarget.style.color = colors.text.secondary;
                  e.currentTarget.style.backgroundColor = '#ffffff';
                }}
              >
                <HiQuestionMarkCircle size={20} />
              </button>
              <NavDropdown
                title={
                  <span
                    className="profile-icon-wrapper"
                    style={{
                      background: `linear-gradient(135deg, ${colors.primary.main}, ${colors.primary.light})`,
                    }}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                }
                id="profile-dropdown"
                className="profile-dropdown-modern"
                align="end"
              >
                <NavDropdown.Item
                  className="profile-dropdown-header"
                  disabled
                >
                  <div className="profile-dropdown-content">Profile</div>
                </NavDropdown.Item>
                <NavDropdown.Divider className="profile-divider" />
                <NavDropdown.Item
                  onClick={handleLogout}
                  className="logout-item-modern"
                >
                  <BiLogOut size={18} />
                  <span>Logout</span>
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
}
